
















import { Vue, Component, Prop } from 'vue-property-decorator';
import { TeacherInfoInputDTO } from '../../../src_server/entity/dto/TeacherInfoInputDTO';
import { dayjs, DT_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { ActorType, ActorTypeNames } from '../../../src_server/biz/ActorType';
import LoginButton from '../../components/login/LoginButton.vue';
import { routeHelper } from '../../utils/routeHelper';
import { MessageDialog } from '../../utils/MessageDialog';
import { DaTeacherService } from '../../biz/remote/DaTeacherService';

@Component({
  components: { LoginButton },
  filters: {
    formatDt(d: Date) {
      return dayjs(d).format(DT_FORMAT_JA);
    },
  },
})
export default class TeachersRow extends Vue {
  password = 'da-teacher';
  // email = 'circle-o-admin@mail.circle-o.jp';
  get email() {
    return this.row.userAuth.user_id;
  }
  @Prop()
  private row!: TeacherInfoInputDTO;

  @Prop()
  private index!: number;

  get schoolYear() {
    return this.row.teacher.target_school_year?.replaceAll('学校', '').replaceAll('年生', '');
  }
  get actorType() {
    if (!this.row.communicate.actor_type) return '';
    return ActorType.getInstanceByName(this.row.communicate.actor_type as ActorTypeNames).typeName;
  }

  async detail() {
    this.$emit('detail', this.row);
  }

  async reservation() {
    routeHelper(this, 'DaLessonReservationCommitPage', { teacher_id: this.row.teacher.user_id, teacher_name: this.row.teacher.nickname });
  }

  async copy() {
    const isOK = await MessageDialog.confirm(`このクラスのコピーを作成します。よろしいですか？`);
    if (isOK) {
      const biz = new DaTeacherService();
      const response = await biz.copyTeachers(this.row.userAuth.user_id!);
      await MessageDialog.alert(`複製を作成しました`);
      console.log(response.data);
      this.$emit('copied', response.data);
    }
  }

  async frameCalendar() {
    routeHelper(this, 'DaCalendarPage', { teacher_id: this.row.teacher.user_id, teacher_name: this.row.teacher.nickname });
  }
}
